/**
 * Shared colour vocabulary for every ASCII sprite.
 *
 * One palette keeps the art coherent: a sprite added six months from now cannot
 * drift into a slightly different green. Characters are mnemonic, and `.` is
 * always transparent.
 */
export const PALETTE = {
  // Katie
  h: '#8a4b2a', // hair
  k: '#5c2f18', // hair shadow
  s: '#f3cda4', // skin
  S: '#d8a377', // skin shadow
  e: '#2b2b3a', // eye
  d: '#57b0a0', // tunic
  D: '#3a8477', // tunic shadow
  w: '#f6f4e8', // apron / trim
  b: '#4b3826', // boots

  // Terrain
  g: '#4e8f4a', // grass
  G: '#3f7a3d', // grass shadow
  y: '#6fae5c', // grass highlight
  t: '#8a6a43', // tilled soil
  T: '#6d5133', // soil shadow
  O: '#5c4429', // watered soil
  p: '#c2a878', // path
  P: '#a88f61', // path shadow
  a: '#4a8fd4', // pond water
  A: '#356fb0', // pond water shadow

  // Props
  n: '#3c6b34', // foliage
  N: '#2c5227', // foliage shadow
  m: '#6b4a2c', // trunk
  M: '#4d341e', // trunk shadow
  f: '#a8814f', // fence
  F: '#7d5f39', // fence shadow
  r: '#9c9c9c', // stone
  R: '#6e6e6e', // stone shadow

  // Interiors
  q: '#c9705f', // bedding
  Q: '#a3503f', // bedding shadow
  W: '#e9e2d6', // pillow

  // Water bodies. Distinct enough to name at a glance from across the screen:
  // still ponds, deep lakes, moving rivers, open ocean.
  E: '#2f5f9e', // lake water
  Y: '#1f4272', // lake depths

  // Crops
  l: '#6fbf5a', // leaf
  L: '#4a8c3d', // leaf shadow
  z: '#d8503f', // tomato
  Z: '#a83a2c', // tomato shadow
  u: '#e8dfc8', // turnip flesh
  U: '#b07fc0', // turnip crown
  c: '#e0873a', // pumpkin
  C: '#b3651f', // pumpkin shadow
  i: '#c9a06a', // potato
  I: '#9a7548', // potato shadow

  // Interior surfaces
  x: '#9a8a76', // interior plaster
  X: '#7a6b59', // interior plaster shadow

  // Shoreline
  // Letters are nearly exhausted, so the shoreline uses digits. Still one
  // character per pixel, still typeable in an ASCII grid.
  K: '#5fb8d8', // river water
  '1': '#3d94b8', // river current
  '2': '#1c7fa0', // ocean water
  '3': '#125c78', // ocean depths
  '4': '#dff0f5', // foam
  '5': '#e5d6a8', // sand
  '6': '#c9b98a', // wet sand

  // Buildings
  j: '#a85a49', // roof shingle
  J: '#7d3a30', // roof shingle shadow
  v: '#8fd0e0', // window glass
  V: '#5f9fb5', // window glass shadow
} as const satisfies Record<string, string>;

export type PaletteKey = keyof typeof PALETTE;
